import { MESSAGE } from '@/constants/notifications';

const FACTOR = 1.5;

export function getElementTop({ container, element, gap = 0 }) {
  const { offsetTop } = element;
  const { clientHeight, scrollHeight } = container;
  return Math.max(0, Math.min(offsetTop - gap, scrollHeight - clientHeight));
}

export function isElementAtTheTop({ container, element, gap = 0 }) {
  if (!element || !container) return undefined;

  const { offsetHeight, offsetTop } = element;
  const { clientHeight, scrollHeight, scrollTop } = container;

  function getMultiplier() {
    return ((scrollTop - scrollHeight) + clientHeight * FACTOR) / (clientHeight * FACTOR - clientHeight);
  }

  const top = scrollTop < scrollHeight - clientHeight * FACTOR
    ? scrollTop + gap
    : scrollTop + gap + (clientHeight - gap) * getMultiplier();

  return offsetTop <= top && offsetTop + offsetHeight >= top;
}

export function createImageElement(attributes) {
  return new Promise(function executor(resolve, reject) {
    const image = new Image();

    image.addEventListener('error', function onError() {
      reject(MESSAGE.FAIL.LOAD_IMAGE);
    });

    image.addEventListener('load', function onLoad() {
      resolve(image);
    });

    for (const [key, value] of Object.entries(attributes)) {
      image[key] = value;
    }
  });
}
